import { withBreakpointObserver, Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} ComponentProps
 */

/**
 * MenuItem component.
 * @augments {Base<ComponentProps>}
 */
export default class MenuItem extends withBreakpointObserver(Base) {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'MenuItem',
    refs: ['btn', 'submenu'],
    emits: ['open-submenu'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s m',
      },
    },
  };

  /**
   * Click on item
   * @param  {object} e current element
   * @returns {void}
   */
  onBtnClick(e) {
    e.preventDefault();
    this.$emit('open-submenu');
    this.$refs.submenu.classList.toggle('hidden');
  }

  /**
   * Close Sub Menu
   * @returns {void}
   */
  closeSubmenu() {
    this.$refs.submenu.classList.add('hidden');
  }
}
